import { createFileRoute, redirect } from "@tanstack/react-router";
import { useChildSessionStore } from "@/lib/stores/childSessionStore";
import { SessionAnimation } from "@/components/ChildSession/SessionAnimation";
import { SessionExerciseLauncher } from "@/components/ChildSession/SessionExerciseLauncher";
import { SessionPause } from "@/components/ChildSession/SessionPause";
import { SessionEmotionCheck } from "@/components/ChildSession/SessionEmotionCheck";
import { SessionOutcome } from "@/components/ChildSession/SessionOutcome";

export const Route = createFileRoute("/(content)/children/session/")({
  beforeLoad: () => {
    const { selectedEmotionId } = useChildSessionStore.getState();
    if (!selectedEmotionId) {
      throw redirect({ to: "/children/exercises" });
    }
    return {
      navbar: {
        showTopbar: false,
        showTitle: false,
        onBack: false,
        transparent: true,
      },
    };
  },
  component: SessionRoute,
});

function SessionRoute() {
  const currentStep = useChildSessionStore((s) => s.currentStep);

  switch (currentStep) {
    case "animation":
      return <SessionAnimation />;
    case "exercise":
      return <SessionExerciseLauncher />;
    case "pause":
      return <SessionPause />;
    case "emotion-check":
      return <SessionEmotionCheck />;
    case "outcome":
      return <SessionOutcome />;
    default:
      return <SessionAnimation />;
  }
}
